import { Icon } from "@/components/ui/icon";



interface PlanBadgeProps {
  variant: "enterprise" | "business" | "addon";
  onClick?: () => void;
}

const VARIANTS = {
  enterprise: {
    bg: "bg-[rgba(205,183,242,0.2)] dark:bg-[#16121D]",
    border: "border-[#BEA8D7] dark:border-[#341853]",
    text: "text-[#8563BE] dark:text-[#c4a0ff]",
    label: "Enterprise Only",
  },
  business: {
    bg: "bg-[rgba(183,210,242,0.2)] dark:bg-[#0d1529]",
    border: "border-[#92B4D7] dark:border-[#1b3272]",
    text: "text-[#2752CA] dark:text-[#5b8ef0]",
    label: "Business Only",
  },
  addon: {
    bg: "bg-[rgba(255,175,83,0.12)] dark:bg-[#1a1408]",
    border: "border-[#D7A854] dark:border-[#53400e]",
    text: "text-[#BE8F3F] dark:text-[#FFAF53]",
    label: "ATS Add-on Required",
  },
} as const;

export function PlanBadge({ variant, onClick }: PlanBadgeProps) {
  const v = VARIANTS[variant];
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`${v.bg} ${v.border} border rounded-md p-0.5 flex items-center gap-0.5 overflow-clip ${onClick ? "cursor-pointer" : ""}`}
    >
      <div className="flex items-center pl-1 pr-0.5">
        <span className={`text-xs font-medium ${v.text} leading-4 whitespace-nowrap`}>
          {v.label}
        </span>
      </div>
      <div className="size-4 flex items-center justify-center shrink-0">
        <Icon
          name="IconArrowUpCircle"
          size={12}
          className={v.text}
        />
      </div>
    </Wrapper>
  );
}
